<template>
  <rkm-modal
        large
        ref="RkmModal"
        title="Laudos"
    >
        <List :laudos="laudos" />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import List from './List'

export default {
    components: {
        List
    },
    computed: {
        laudos() {

            if (this.pedidoExameId == null) return []

            return this.data.form.pedidosExames.find(p => p.id === this.pedidoExameId).files
        }
    },
    data: () => ({

        pedidoExameId: null
    }),
    methods:{
        open(pedidoExameId) {

            this.pedidoExameId = pedidoExameId

            this.$refs.RkmModal.show()
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>